import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { EmailVerification } from "@unisearch/auth";

const Verification = () => {
  return (
    <LayoutMain
      title="Email Verification"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/email-verification`}
    >
      <EmailVerification />
    </LayoutMain>
  );
};

export default Verification;
